// src/components/Gallery.js
import React, { useState } from "react";
import Slider from "react-slick";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "./gallery.scss";

export const Gallery = ({ images = [], title = "Galería" }) => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 2250,
    responsive: [
      {
        breakpoint: 980, // versión móvil
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 380, // versión móvil
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleClickImage = (i) => {
    setIndex(i);
    setOpen(true);
  };

  return (
    <div className="sec_gallery">
      <div className="container-lg">
        <h2 className="ttls ttl_section c_morado mb-2 text-center">{title}</h2>
        <p className="paragraph lg c_marin fw_500 text-center">
          Galería de fotos
        </p>
        <Slider {...settings}>
          {images.map((image, i) => (
            <div className="box_item_gallery" key={i}>
              <div
                className="item_gallery"
                style={{ backgroundImage: `url(${image})` }}
                onClick={() => handleClickImage(i)}
              ></div>
            </div>
          ))}
        </Slider>

        <Lightbox
          open={open}
          close={() => setOpen(false)}
          index={index}
          slides={images.map((src) => ({ src }))}
        />
      </div>
    </div>
  );
};

// import React, { useState } from "react";
// import { useTranslation } from "react-i18next";
// import Slider from "react-slick";
// import Lightbox from "yet-another-react-lightbox";
// import "yet-another-react-lightbox/styles.css";
// import "./gallery.scss";

// import ico01 from "../../assets/imgs/gallery/Carrusel01.webp";
// import ico02 from "../../assets/imgs/gallery/Carrusel02.webp";
// import ico03 from "../../assets/imgs/gallery/Carrusel03.webp";
// import ico04 from "../../assets/imgs/gallery/Carrusel04.webp";
// import ico05 from "../../assets/imgs/gallery/Carrusel05.webp";
// import ico06 from "../../assets/imgs/gallery/Carrusel06.webp";
// import ico07 from "../../assets/imgs/gallery/Carrusel07.webp";
// import ico08 from "../../assets/imgs/gallery/Carrusel08.webp";
// import ico09 from "../../assets/imgs/gallery/Carrusel09.webp";

// const photos = [ico01, ico02, ico03, ico04, ico05, ico06, ico07, ico08, ico09];

// export const Gallery = () => {
//   const { t } = useTranslation();
//   const [open, setOpen] = useState(false);
//   const [index, setIndex] = useState(0);

//   const settings = {
//     arrows: false,
//     dots: false,
//     infinite: true,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     autoplay: true,
//     speed: 500,
//     autoplaySpeed: 2250,
//   };

//   const handleClickImage = (i) => {
//     setIndex(i);
//     setOpen(true);
//   };

//   return (
//     <div className="sec_gallery">
//       <div className="container-lg">
//         <h2 className="ttls ttl_section c_morado mb-2 text-center">
//           {t("Galería")}
//         </h2>
//         <Slider {...settings}>
//           {photos.map((image, i) => (
//             <div className="box_item_gallery">
//               <div
//                 className="item_gallery"
//                 style={{ backgroundImage: `url(${image})` }}
//                 key={i}
//                 onClick={() => handleClickImage(i)}
//               ></div>
//             </div>
//           ))}
//         </Slider>
//         {/* <Slider {...settings}>
//           {photos.map((image, i) => (
//             <div key={i}>
//               <img
//                 src={image}
//                 alt={`gallery-${i}`}
//                 onClick={() => handleClickImage(i)}
//                 style={{ cursor: "pointer" }}
//               />
//             </div>
//           ))}
//         </Slider> */}
//         <Lightbox
//           open={open}
//           close={() => setOpen(false)}
//           index={index}
//           slides={photos.map((src) => ({ src }))}
//         />
//       </div>
//     </div>
//   );
// };
